<template>
    <div>
        <div v-if="historicoStatus == false">
            <h1 class="h3 mb-3 text-gray-800">{{ $t("Editar Técnico") }}</h1>

            <loading-animation
                :active.sync="loading"
                :is-full-page="false"
                :opacity="1"
                color="#5895FF"
            />
            <form @submit.prevent="addItem" ref="addItem">
                <div class="row">
                    <form-input
                        grid="9"
                        v-model="item.nome"
                        :required="true"
                        label="Nome"
                    />
                    <form-input
                        grid="3"
                        v-model="item.cpf"
                        v-mask="'###.###.###-##'"
                        label="CPF"
                    />
                    <form-input
                        grid="3"
                        label="Data de Nascimento"
                        v-model="item.data_nascimento"
                        v-mask="'##/##/####'"
                        :required="true"
                    />
                    <form-select
                        grid="3"
                        v-model="item.sexo"
                        :itens="$root.arrays.sexo"
                        :required="true"
                        placeholder="Selecione"
                        label="Sexo"
                    />

                    <form-input
                        grid="3"
                        v-model="item.telefone"
                        v-mask="'(##) #####-####'"
                        placeholder="(00) 00000-0000"
                        label="Telefone"
                    />
                    <form-input
                        grid="3"
                        v-model="item.whatsapp"
                        v-mask="'(##) #####-####'"
                        placeholder="(00) 00000-0000"
                        label="Whatsapp"
                    />
                    <form-input
                        grid="6"
                        v-model="item.profissao"
                        label="Cargo"
                    />
                    <form-select
                        grid="6"
                        v-model="item.escolaridade"
                        :itens="$root.arrays.tiposEscolaridadeTecnicos"
                        :required="true"
                        placeholder="Selecione"
                        label="Escolaridade"
                    />
                    <div class="col-md-12">
                        <h3>Informação da Unidade</h3>
                    </div>
                    <form-select
                        grid="12"
                        v-model="item.role_id"
                        :itens="roles"
                        :required="true"
                        placeholder="Selecione uma Função"
                        label="Função na Unidade/Sistema"
                        :disabled="disabledRole"
                    />
                    <form-select
                        grid="4"
                        v-model="item.regime_trabalho"
                        :itens="$root.arrays.regimeTrabalhoTecnicos"
                        placeholder="Selecione"
                        label="Regime de Trabalho"
                    />

                    <form-calendar
                        v-model="item.data_admissao"
                        grid="4"
                        label="Data de Vinculação"
                    />

                    <form-calendar
                        v-model="item.data_desvinculacao"
                        grid="4"
                        label="Data de Desvinculação"
                    />

                    <form-select
                        grid="4"
                        v-model="item.carga_horaria"
                        :itens="$root.arrays.cargaHorariaTecnicos"
                        :required="true"
                        placeholder="Selecione"
                        label="Carga Horária"
                    />
                    <div class="col-md-12">
                        <h3>Dados de Acesso ao Sistema</h3>
                    </div>
                    <form-input
                        grid="3"
                        v-model="item.email"
                        :required="true"
                        label="E-mail"
                    />
                    <div class="col-md-3">
                        <b-form-group class="mb-2" label-for="password">
                            <template v-slot:label
                                >{{ $t("Senha") }}
                                <span class="text-danger">*</span></template
                            >
                            <b-input-group>
                                <b-form-input
                                    :type="passwordInput"
                                    id="password"
                                    v-model="item.password"
                                />
                                <b-input-group-append style="height: 35px">
                                    <b-button
                                        :title="$t('Show/Hide password')"
                                        @click="showPassword"
                                        class="px-2"
                                        type="button"
                                        v-b-tooltip.hover
                                        variant="primary"
                                    >
                                        <i
                                            class="fas fa-fw fa-eye"
                                            v-if="passwordInput === 'password'"
                                        />
                                        <i
                                            class="fas fa-fw fa-eye-slash"
                                            v-else
                                        />
                                    </b-button>
                                    <b-button
                                        :title="$t('Generate new password')"
                                        @click="generatePassword"
                                        class="px-2"
                                        type="button"
                                        v-b-tooltip.hover
                                        variant="secondary"
                                    >
                                        <i class="fas fa-fw fa-sync" />
                                    </b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-form-group>
                    </div>
                    <form-calendar
                        grid="3"
                        v-model="item.validade"
                        label="Validade do Cadastro"
                    />
                    <form-select
                        @change="verificarStatus"
                        v-model="item.status"
                        label="Status"
                        grid="3"
                        :itens="status"
                        :ajuda="
                            $t(
                                'When the user is deactivated, the registry is created in the system, so the email is reserved, but can not login until it is activated again'
                            )
                        "
                    />

                    <form-textarea-editor
                        v-model="item.observacoes"
                        label="Observação"
                        grid="12"
                    />
                </div>

                <div class="float-right mt-3">
                    <a
                        class="router-link-exact-active active px-3"
                        @click="historicoStatus = true"
                    >
                        <i class="fas fa-history"></i> Histórico de Status
                    </a>
                    <button
                        class="btn btn-default"
                        data-style="zoom-in"
                        type="button"
                        @click.prevent="$parent.page = 'tecnicos'"
                    >
                        <i class="mdi mdi-arrow-left" />
                    </button>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </form>
        </div>
        <div class="row" v-else>
            <div class="col-12">
                <h4 class="font-weight-bold">Técnico {{ item.nome }}</h4>
            </div>
            <HistoricoStatus
                @voltar="historicoStatus = false"
                :id="item.id"
                :familia="0"
                :status="status_item"
            />
        </div>

        <status-historico
            :model="model"
            modulo="Tecnico"
            titulo_modulo="TÉCNICO"
            :id="item.id"
            :status-anterior="statusAnterior"
            :status-atual="statusAtual"
            :status="status_item"
            @submit="addItem"
        />
    </div>
</template>

<script>
import HistoricoStatus from "../../../../../../../Tecnico/Resources/assets/js/HistoricoStatus";
export default {
    props: {
        tecnico: {
            type: Number,
            required: true,
        },
    },
    components: {
        HistoricoStatus,
    },
    name: "Edit",
    mounted() {
        this.getStatus();
        this.getRoles();
        this.getTecnico();
        this.getStatusFinais();
    },
    data() {
        return {
            loadingSearchUnidade: false,
            loading: true,
            tecnicosList: [],
            localidades: [],
            localidade: {},
            logradouros: [],
            logradouro: {},
            unidadesList: [],
            passwordInput: "password",
            item: {},
            roles: [],
            disabledRole: false,
            model: "Tecnico",
            status: {},
            status_item: [],
            statusAtual: "",
            statusAnterior: "",
            historicoStatus: false,
        };
    },
    methods: {
        getTecnico() {
            this.loading = true;
            axios
                .get("api/dashboard/tecnicos/" + this.tecnico)
                .then((response) => {
                    this.item = response.data.data;
                    this.statusAnterior = this.item.status;
                    if (this.item.role_id == 1) {
                        this.item.role_id = {
                            id: 1,
                            value: "Admin",
                        };
                        this.disabledRole = true;
                    }
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch((error) => {
                    swal.fire({
                        title: "Ops!",
                        html:
                            "O item não foi carregado corretamente<br>" + error,
                        icon: "error",
                    });
                });
        },
        getStatus() {
            axios.get(`api/dashboard/status/tecnicos`).then((response) => {
                this.status = response.data;
            });
        },
        verificarStatus(status) {
            this.statusAtual = status;

            const result = this.status_item.filter((item) => item.id == status);
            if (result[0].final == 1) {
                //compara os status finais com o status que foi alterado, caso seja igual será aberta a janela para salva o historico
                this.$bvModal.show("status-historico-" + this.model);
            }
        },
        getStatusFinais() {
            axios
                .post(`api/dashboard/get/status/finais`, {
                    model: this.model,
                    module: this.model,
                })
                .then((response) => {
                    this.status_item = response.data;
                });
        },
        addItem() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();

            if (this.item.role_id.value == "Admin") {
                this.item.role_id = 1;
            }

            // if (this.item.data_admissao) {
            //   this.item.data_admissao = moment(
            //     this.item.data_admissao,
            //     "YYYY-MM-DD"
            //   ).format("DD/MM/YYYY");
            // }

            // Send request
            axios
                .put("api/dashboard/tecnicos/" + this.item.id, this.item)
                .then((response) => {
                    ladda.stop();
                    this.getTecnico();
                    this.$snack.success({
                        button: false,
                        text: response.data.data.message,
                    });
                });
        },
        // Show the password input
        showPassword() {
            if (this.passwordInput === "password") {
                this.passwordInput = "text";
            } else {
                this.passwordInput = "password";
            }
        },
        // Generate new password
        generatePassword() {
            this.item.password = window.GeneratePassword.generate({
                length: 8,
                numbers: true,
                symbols: false,
                excludeSimilarCharacters: true,
                strict: true,
            });
        },
        getRoles() {
            this.loading = true;
            // Get all settings values
            axios.get("api/dashboard/users/roles").then((response) => {
                if (response.data.data) {
                    this.roles = response.data.data.map((elem) => ({
                        id: elem.id,
                        value: elem.name,
                    }));
                }
                this.loading = false;
            });
        },
        onSearchUnidade(search, loading) {
            loading(true);
            this.searchUnidade(loading, search, this);
        },
        searchUnidade(search) {
            this.loadingSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/pesquisar?q=${escape(search)}`)
                .then((response) => {
                    this.unidadesList = response.data;
                    // loading(false);
                })
                .finally(() => {
                    this.loadingSearchUnidade = false;
                });
        },
        onSearchLocalidade(search, loading) {
            loading(true);
            this.searchLocalidade(loading, search, this);
        },
        searchLocalidade(loading, search, vm) {
            axios
                .get(
                    `api/dashboard/enderecos/pesquisar_bairro?q=${escape(
                        search
                    )}`
                )
                .then((response) => {
                    this.localidades = response.data;
                    loading(false);
                });
        },
        setSelected(value) {
            axios
                .get(
                    `api/dashboard/enderecos/pesquisar_logradouro?logradouro=${escape(
                        value.id
                    )}`
                )
                .then((response) => {
                    this.logradouros = response.data;
                });
        },
    },
};
</script>
